<template>
  <RevButton
    data-qa="get-more-help"
    data-test="get-more-help"
    full-width="adaptive"
    :loading="isIntercomPending"
    :variant
    @click="openChat"
  >
    {{ i18n(translations.label) }}
  </RevButton>
  <Intercom data-test="intercom" :manual="true" />
</template>

<script lang="ts" setup>
import { navigateTo, useRouteLocationWithLocale } from '#imports'
import { computed, ref } from 'vue'

import Intercom from '@backmarket/nuxt-layer-care-platform/intercom/components/Intercom.vue'
import { useIntercom } from '@backmarket/nuxt-layer-care-platform/intercom/composables/useIntercom'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { toNuxtLink } from '@backmarket/nuxt-module-navigation/toNuxtLink'
import { RevButton } from '@ds/components/Button'

import { RESOLUTION_OPTION_SERVICE_NAME_ENUM } from '~/api/resolution-engine/types/Common.types'
import { CUSTOMER_CONVERSATION } from '~/scopes/customer-conversation/route-names'

import translations from './GetMoreHelpAction.translations'
import type { GetMoreHelpActionProps } from './GetMoreHelpAction.types'

const { resolution, variant = 'secondary' } =
  defineProps<GetMoreHelpActionProps>()

const i18n = useI18n()
const injectLocale = useRouteLocationWithLocale()

const { intercom, status, load } = useIntercom()

const isIntercomPending = ref<boolean>(false)

const conversationRoute = toNuxtLink(
  injectLocale({
    type: 'internal',
    name: CUSTOMER_CONVERSATION.RESOLUTION,
    params: {
      resolutionId: resolution.id,
    },
  }),
)

const isAfterSalesResolutionOption = computed(
  () =>
    resolution.resolutionOption.serviceName ===
    RESOLUTION_OPTION_SERVICE_NAME_ENUM.afterSales,
)

async function openIntercomConversation() {
  if (resolution.externalId) {
    try {
      isIntercomPending.value = true
      if (status.value !== 'loaded') {
        await load()
      }
      intercom('showConversation', resolution.externalId)
      isIntercomPending.value = false
    } catch (e) {
      isIntercomPending.value = false
    }
  }
}

const openChat = () => {
  if (isAfterSalesResolutionOption.value) {
    return openIntercomConversation()
  }

  return navigateTo(conversationRoute)
}
</script>
